module.exports = __webpack_public_path__ + "img/file.82fe6ee3.svg";